import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-container"
}
const _hoisted_2 = { class: "modal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modalOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            _createElementVNode("button", {
              type: "button",
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "17",
                height: "17",
                viewBox: "0 0 17 17",
                fill: "none"
              }, [
                _createElementVNode("rect", {
                  x: "1.36133",
                  width: "22.1161",
                  height: "1.92314",
                  rx: "0.961571",
                  transform: "rotate(45 1.36133 0)",
                  fill: "white"
                }),
                _createElementVNode("rect", {
                  x: "16.998",
                  y: "1.35974",
                  width: "22.1161",
                  height: "1.92314",
                  rx: "0.961571",
                  transform: "rotate(135 16.998 1.35974)",
                  fill: "white"
                })
              ], -1)
            ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}